var React = require('react');

function IconStarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"icon","d":"M19.7147 6.87811C19.8045 6.60172 20.1955 6.60172 20.2853 6.87812L23.3004 16.1574C23.3405 16.2811 23.4557 16.3647 23.5857 16.3647H33.3425C33.6332 16.3647 33.754 16.7366 33.5189 16.9075L25.6254 22.6424C25.5203 22.7188 25.4763 22.8542 25.5164 22.9778L28.5315 32.2571C28.6213 32.5335 28.3049 32.7634 28.0698 32.5925L20.1763 26.8576C20.0712 26.7812 19.9288 26.7812 19.8237 26.8576L11.9302 32.5925C11.6951 32.7634 11.3787 32.5335 11.4685 32.2571L14.4836 22.9778C14.5237 22.8542 14.4797 22.7188 14.3746 22.6424L6.48112 16.9075C6.24601 16.7366 6.36684 16.3647 6.65746 16.3647H16.4143C16.5443 16.3647 16.6595 16.2811 16.6996 16.1575L19.7147 6.87811Z","stroke":"#5D5146","strokeWidth":"2.5"}));
}

IconStarInline.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = IconStarInline;

IconStarInline.default = IconStarInline;
